import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface IProfileResponse {
  message: string;
  payload?: IProfilePayload;
}

export interface IProfilePayload {
  id: string;
  userId: string;
  channelsMap: IChannelsMap;
}

export interface IChannelsMap {
  SMS: boolean;
  WHATSAPP: boolean;
  EMAIL: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private api: ApiService) {}

  getProfile(): Observable<IProfileResponse> {
    return this.api.GET<IProfileResponse>('profile');
  }

  updateNotificationPreferences(
    payload: IChannelsMap
  ): Observable<IProfileResponse> {
    return this.api.PATCH<IProfileResponse>('profile/notification-channels', payload);
  }
}
